import React, { useState } from 'react';
import { LayoutDashboard, Users, Building, FileText, Phone, Mail, MoreHorizontal, Plus } from 'lucide-react';
import { DashboardLayout } from '../../components/DashboardLayout';
import { AddLeadModal } from '../../components/modals/AddLeadModal';
import { useNavigate } from 'react-router-dom';
export function LeadsCrmPage() {
  const navigate = useNavigate();
  const [isAddLeadModalOpen, setIsAddLeadModalOpen] = useState(false);
  const navItems = [{
    label: 'Overview',
    icon: LayoutDashboard,
    path: '/dashboard/developer'
  }, {
    label: 'Inventory',
    icon: Building,
    path: '/developer/inventory'
  }, {
    label: 'Leads & CRM',
    icon: Users,
    path: '/developer/leads'
  }, {
    label: 'Reports',
    icon: FileText,
    path: '/developer/reports'
  }];
  const handleLeadClick = (leadId: string) => {
    navigate(`/developer/leads/${leadId}`);
  };
  const handleAddNewLead = () => {
    setIsAddLeadModalOpen(true);
  };
  return <DashboardLayout title="Developer Console" personaLabel="DEVELOPER" personaColor="bg-blue-100 text-blue-800 border-blue-200" navItems={navItems} userInitials="DL" data-id="element-3908">
      <div className="flex justify-between items-center mb-8" data-id="element-3909">
        <h1 className="text-2xl font-bold" data-id="element-3910">Lead Pipeline</h1>
        <button onClick={handleAddNewLead} className="flex items-center gap-2 px-4 py-2 bg-[#1f2933] text-white text-sm font-bold hover:bg-gray-800" data-id="element-3911">
          <Plus className="w-4 h-4" data-id="element-3912" />
          Add New Lead
        </button>
      </div>

      <div className="flex gap-4 overflow-x-auto pb-4 min-h-[500px]" data-id="element-3913">
        {/* New Inquiries Column */}
        <div className="w-80 shrink-0" data-id="element-3914">
          <div className="bg-gray-200 p-3 rounded-t-sm border-b-2 border-blue-500 font-bold text-sm flex justify-between" data-id="element-3915">
            <span data-id="element-3916">New Inquiries</span>
            <span className="bg-gray-300 px-2 rounded-full text-xs flex items-center" data-id="element-3917">
              12
            </span>
          </div>
          <div className="bg-gray-100 p-2 space-y-3 min-h-[400px]" data-id="element-3918">
            {[{
            id: '1',
            name: 'Rohan Gupta',
            interest: 'Green Valley',
            time: '2h ago',
            score: 'High',
            phone: '+91 98765...'
          }, {
            id: '2',
            name: 'Meera Nair',
            interest: 'Sunrise Hts',
            time: '5h ago',
            score: 'Med',
            phone: '+91 98123...'
          }, {
            id: '3',
            name: 'Vikram Singh',
            interest: 'Green Valley',
            time: '1d ago',
            score: 'Low',
            phone: '+91 97654...'
          }].map(lead => <div key={lead.id} onClick={() => handleLeadClick(lead.id)} className="bg-white p-3 border border-gray-300 shadow-sm cursor-pointer hover:shadow-md transition-shadow" data-id="element-3919">
                <div className="flex justify-between mb-2" data-id="element-3920">
                  <span className="font-bold text-sm" data-id="element-3921">{lead.name}</span>
                  <button onClick={e => {
                e.stopPropagation();
              }} data-id="element-3922">
                    <MoreHorizontal className="w-4 h-4 text-gray-400" data-id="element-3923" />
                  </button>
                </div>
                <div className="text-xs text-gray-500 mb-2" data-id="element-3924">
                  {lead.interest}
                </div>
                <div className="flex gap-1 mb-2" data-id="element-3925">
                  <button onClick={e => {
                e.stopPropagation();
              }} className="p-1 hover:bg-gray-100 rounded" data-id="element-3926">
                    <Phone className="w-3 h-3 text-gray-500" data-id="element-3927" />
                  </button>
                  <button onClick={e => {
                e.stopPropagation();
              }} className="p-1 hover:bg-gray-100 rounded" data-id="element-3928">
                    <Mail className="w-3 h-3 text-gray-500" data-id="element-3929" />
                  </button>
                </div>
                <div className="flex justify-between items-center mt-3" data-id="element-3930">
                  <span className={`text-[10px] font-bold px-1.5 py-0.5 rounded ${lead.score === 'High' ? 'bg-green-100 text-green-800' : 'bg-yellow-100 text-yellow-800'}`} data-id="element-3931">
                    {lead.score} Intent
                  </span>
                  <span className="text-[10px] text-gray-400" data-id="element-3932">{lead.time}</span>
                </div>
              </div>)}
          </div>
        </div>

        {/* Site Visits Column */}
        <div className="w-80 shrink-0" data-id="element-3933">
          <div className="bg-gray-200 p-3 rounded-t-sm border-b-2 border-purple-500 font-bold text-sm flex justify-between" data-id="element-3934">
            <span data-id="element-3935">Site Visits</span>
            <span className="bg-gray-300 px-2 rounded-full text-xs flex items-center" data-id="element-3936">
              5
            </span>
          </div>
          <div className="bg-gray-100 p-2 space-y-3 min-h-[400px]" data-id="element-3937">
            {[{
            id: '4',
            name: 'Anjali Deshmukh',
            date: 'Tomorrow, 10 AM',
            phone: '+91 98...',
            status: 'Scheduled'
          }, {
            id: '5',
            name: "Robert D'souza",
            date: 'Oct 28, 4 PM',
            phone: '+91 99...',
            status: 'Confirmed'
          }].map(lead => <div key={lead.id} onClick={() => handleLeadClick(lead.id)} className="bg-white p-3 border border-gray-300 shadow-sm cursor-pointer hover:shadow-md transition-shadow" data-id="element-3938">
                <div className="flex justify-between mb-2" data-id="element-3939">
                  <span className="font-bold text-sm" data-id="element-3940">{lead.name}</span>
                  <div className="flex gap-1" data-id="element-3941">
                    <button onClick={e => {
                  e.stopPropagation();
                }} className="p-1 hover:bg-gray-100 rounded" data-id="element-3942">
                      <Phone className="w-3 h-3 text-gray-500" data-id="element-3943" />
                    </button>
                    <button onClick={e => {
                  e.stopPropagation();
                }} className="p-1 hover:bg-gray-100 rounded" data-id="element-3944">
                      <Mail className="w-3 h-3 text-gray-500" data-id="element-3945" />
                    </button>
                  </div>
                </div>
                <div className="flex items-center gap-2 text-xs text-gray-600 bg-purple-50 p-2 rounded mb-2" data-id="element-3946">
                  {lead.date}
                </div>
                <div className="text-[10px] text-gray-400 text-right" data-id="element-3947">
                  Added 3 days ago
                </div>
              </div>)}
          </div>
        </div>

        {/* Negotiation Column */}
        <div className="w-80 shrink-0" data-id="element-3948">
          <div className="bg-gray-200 p-3 rounded-t-sm border-b-2 border-orange-500 font-bold text-sm flex justify-between" data-id="element-3949">
            <span data-id="element-3950">Negotiation</span>
            <span className="bg-gray-300 px-2 rounded-full text-xs flex items-center" data-id="element-3951">
              3
            </span>
          </div>
          <div className="bg-gray-100 p-2 space-y-3 min-h-[400px]" data-id="element-3952">
            <div onClick={() => handleLeadClick('6')} className="bg-white p-3 border border-gray-300 shadow-sm cursor-pointer hover:shadow-md border-l-4 border-l-orange-500" data-id="element-3953">
              <div className="font-bold text-sm mb-1" data-id="element-3954">Suresh Reddy</div>
              <div className="text-xs text-gray-500 mb-2" data-id="element-3955">
                Plot A-105 • Offer: ₹42L
              </div>
              <div className="text-xs bg-orange-50 text-orange-800 p-1.5 rounded" data-id="element-3956">
                Counter offer sent: ₹44L
              </div>
            </div>
          </div>
        </div>

        {/* Closed Column */}
        <div className="w-80 shrink-0" data-id="element-3957">
          <div className="bg-gray-200 p-3 rounded-t-sm border-b-2 border-green-500 font-bold text-sm flex justify-between" data-id="element-3958">
            <span data-id="element-3959">Closed / Booked</span>
            <span className="bg-gray-300 px-2 rounded-full text-xs flex items-center" data-id="element-3960">
              8
            </span>
          </div>
          <div className="bg-gray-100 p-2 space-y-3 min-h-[400px]" data-id="element-3961">
            <div className="bg-white p-3 border border-gray-300 shadow-sm opacity-75" data-id="element-3962">
              <div className="font-bold text-sm mb-1 line-through text-gray-500" data-id="element-3963">
                Pooja Hegde
              </div>
              <div className="text-xs text-gray-500" data-id="element-3964">
                Plot C-301 • Sold: ₹52L
              </div>
              <div className="text-[10px] text-green-600 font-bold mt-1" data-id="element-3965">
                Token Received
              </div>
            </div>
          </div>
        </div>
      </div>

      <AddLeadModal isOpen={isAddLeadModalOpen} onClose={() => setIsAddLeadModalOpen(false)} data-id="element-3966" />
    </DashboardLayout>;
}